import { render } from "./newTable.vue?vue&type=template&id=7dd9a4ac&scoped=true&ts=true"
import script from "./newTable.vue?vue&type=script&lang=ts"
export * from "./newTable.vue?vue&type=script&lang=ts"

import "./newTable.vue?vue&type=style&index=0&id=7dd9a4ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd9a4ac"]])

export default __exports__